import React from 'react';
import Typography from '@mui/material/Typography';
import { useFormikContext } from 'formik';
import _get from 'lodash.get';

export default function HandleError({ name }) {
  const { errors, touched } = useFormikContext();
  if (_get(errors, name) && _get(touched, name)) {
    return (
      <Typography
        gutterBottom
        variant="caption"
        component="div"
        sx={{
          color: 'red',
          paddingTop: '.2rem',
        }}
      >
        {_get(errors, name)}
      </Typography>
    );
  }
  return null;
}
